export default "__VITE_ASSET__WHWYR9VTD7dEUiHz2n_ocA__";